import { render } from "./Order_management_detail.vue?vue&type=template&id=e34b93ca&scoped=true"
import script from "./Order_management_detail.vue?vue&type=script&lang=js"
export * from "./Order_management_detail.vue?vue&type=script&lang=js"

import "./Order_management_detail.vue?vue&type=style&index=0&id=e34b93ca&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e34b93ca"]])

export default __exports__